import { render, staticRenderFns } from "./TaskTimestamp.vue?vue&type=template&id=7f460e92&"
import script from "./TaskTimestamp.vue?vue&type=script&lang=ts&"
export * from "./TaskTimestamp.vue?vue&type=script&lang=ts&"
import style0 from "./TaskTimestamp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports